import { render } from "./trade-assistant.vue?vue&type=template&id=fc2887b0"
import script from "./trade-assistant.vue?vue&type=script&lang=js"
export * from "./trade-assistant.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__